var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon_\\u8907\\u88FD",
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_588",
    "data-name": "\\u30D1\\u30B9 588",
    d: "M0,0H18V18H0Z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_589",
    "data-name": "\\u30D1\\u30B9 589",
    d: "M11.579,1H3.368A1.418,1.418,0,0,0,2,2.455V12.636H3.368V2.455h8.211Zm2.053,2.909H6.105A1.418,1.418,0,0,0,4.737,5.364V15.545A1.418,1.418,0,0,0,6.105,17h7.526A1.418,1.418,0,0,0,15,15.545V5.364A1.418,1.418,0,0,0,13.632,3.909Zm0,11.636H6.105V5.364h7.526Z",
    transform: "translate(0 0)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCopy);
export default __webpack_public_path__ + "static/media/icon_copy.66c8af0e35bfcd5b45eab12aa0e9bbf1.svg";
export { ForwardRef as ReactComponent };